import { Swiper, Navigation, Keyboard, A11y, Pagination } from 'swiper';

const lockupIconTeaserCarouselSections = document.querySelectorAll(".adm-section-c31-carousel");

for (const lockupSection of lockupIconTeaserCarouselSections) {
    setTimeout(() => { // Next frame delay - time for SVG to be injected
        const pagination = lockupSection.querySelector(".adm-c31-carousel-span-selected");
        const swiperc31 = new Swiper(lockupSection.firstElementChild, {
            modules: [Navigation, Keyboard, A11y],
            direction: "vertical",
            loop: true,
            noSwiping: true,
            navigation: {
                nextEl: lockupSection.querySelector(".adm-btn-c31-carousel-arrow-down"),
                prevEl: lockupSection.querySelector(".adm-btn-c31-carousel-arrow-up")
            },
            keyboard: {
                enabled: true,
                onlyInViewPort: false
            },
            a11y: false,
        });

        swiperc31.on("realIndexChange", () => adjustPagination(swiperc31, pagination));
        addTabIndexToSlides(swiperc31);
    }, 200);
}

function adjustPagination(swiperc31, pagination) {
    if (swiperc31.realIndex < 10) {
        pagination.innerHTML = `0${swiperc31.realIndex + 1}`;
    } else {
        pagination.innerHTML = swiperc31.realIndex + 1;
    }
    setTimeout(() => addTabIndexToSlides(swiperc31), 200);
}

//keyboard accessibility
function addTabIndexToSlides(swiperc31) {
    for (const slide of swiperc31.slides) {
        const allLinks = slide.querySelectorAll("a");
        if (slide.classList.contains("swiper-slide-active")) {
            slide.setAttribute("tabindex", "0");
            for (const link of allLinks) {
                link.setAttribute("tabindex", "0");
            }
        } else {
            slide.setAttribute("tabindex", "-1");
            for (const link of allLinks) {
                link.setAttribute("tabindex", "-1");
            }
        }
    }
}

//mobile swiper
const lockupIconTeaserCarouselSectionsMobile = document.querySelectorAll(".adm-section-c31-carousel-mobile");
Array.prototype.forEach.call(lockupIconTeaserCarouselSectionsMobile, (section, index) => {
    section.classList.add(`section-${index}`);
    new Swiper(`.adm-section-c31-carousel-mobile.section-${index} .swiper`,
        {
            modules: [Navigation, A11y, Pagination],
            slidesPerView: 4,
            spaceBetween: 24,
            slidesPerGroup: 1,
            centeredSlides: true,
            pagination: {
                el: section.querySelector(".adm-div-c31-slider-mobile-controls .adm-div-c31-slider-pagination"),
                type: "fraction",
                formatFractionCurrent: function (number) {
                    return number.toString().padStart(2, '0')
                },
                formatFractionTotal: function (number) {
                    return number.toString().padStart(2, '0')
                }
            },
            navigation: {
                nextEl: section.querySelector(".adm-div-c31-slider-right-arrow"),
                prevEl: section.querySelector(".adm-div-c31-slider-left-arrow"),
            },
            a11y: false,
        });
});